<template>
  <div>
    <b-modal id="main-modal" ref="main-modal" :modal-class="modalClasses" :dialog-class="dialogClasses"
             content-class="modal-content rounded-0 border-0 pb-4" body-class="modal-body"
             header-class="border-bottom-0" hide-footer>
      <component :is="modalSettings.component" ref="modalData" @hook:mounted="modalLoaded"></component>
    </b-modal>
  </div>
</template>

<script>

export default {
  components: {
    BuildingData: () => import('@components/BuildingData/BuildingDataModalComponent'),
    LtmDe: () => import('@components/BuildingData/Partials/de/LtmModalComponent'),
    LtmAt: () => import('@components/BuildingData/Partials/at/LtmModalComponent'),
    LtmDuplicate: () => import('@components/BuildingData/LtmDuplicateModalComponent'),
    PrintPDF: () => import('@components/BuildingData/PrintPDFModal'),

    RoomRecording: () => import('@components/RoomRecording/Partials/de/RoomRecordingModalComponent.vue'),
    RoomRecordingAt: () => import('@components/RoomRecording/Partials/at/RoomRecordingModalComponent.vue'),
    RoomDelete: () => import('@components/RoomRecording/Partials/de/RoomDeleteModalComponent.vue'),
    RoomDeleteAt: () => import('@components/RoomRecording/Partials/at/RoomDeleteModalComponent.vue'),
    UnitDuplicate: () => import('@components/RoomRecording/UnitDuplicateModalComponent.vue'),

    Overflow: () => import('@components/AirvolumeAndDetails/OverflowModalComponent.vue'),
    AirDistribution: () => import('@components/AirvolumeAndDetails/AirDistributionModalComponent.vue'),
    ConnectionDetails: () => import('@components/AirvolumeAndDetails/ConnectionDetailsModalComponent.vue'),

    SaveConfiguration: () => import('@components/SaveConfigurationModalComponent.vue'),
    DownloadModal: () => import('@components/Overview/DownloadModalComponent'),
    UserArticleModal: () => import('@components/UserArticleModalComponent'),
  },
  data() {
    return {
      i: 0,
      modalClasses: ['modal', 'right', 'fade'],
      dialogClasses: ['modal-dialog', 'modal_xl', 'shadow-lg', 'mx-0'],
    }
  },
  methods: {
    testFunction() {
      var test = ['BuildingData', 'BuildingData']
      this.$store.dispatch('modalSettings/setComponent', test[this.i])
      this.$store.dispatch('modalSettings/callRef')
      this.$store.dispatch('modalSettings/open')

      this.i++
      if (this.i > test.length - 1) this.i = 0
    },
    setData() {
      this.$refs.modalData.setData(this.modalSettings.Payload.Data)
    },
    modalLoaded() {
      this.modalSettings.isLoaded = true
    },
  },
  computed: {
    modalSettings: {
      get() {
        return this.$store.state.modalSettings.value
      },
      set(value) {
        this.$store.commit('modalSettings/updatemodalSettings', value)
      },
    },
  },
  watch: {
    modalSettings: {
      deep: true,
      handler() {
        if (this.modalSettings.isLarge) {
          this.modalClasses = ['modal', 'right', 'fade', 'larg-modal']
          this.dialogClasses = ['modal-dialog', 'modal_xl', 'shadow-lg', 'mx-0', 'larg-modal']
        } else {
          this.modalClasses = ['modal', 'right', 'fade']
          this.dialogClasses = ['modal-dialog', 'modal_xl', 'shadow-lg', 'mx-0']
        }
        if (this.modalSettings.callRef == true && this.modalSettings.isLoaded == true) {
          if ((this.modalSettings.withPayload = true)) {
            this.$refs.modalData.setData(this.modalSettings.Payload)
            this.modalSettings.withPayload = false
          } else {
            this.$refs.modalData.setData()
          }
          this.modalSettings.callRef = false
          this.modalSettings.Payload = {}
        }
        if (this.modalSettings.openModal == true) {
          this.$refs['main-modal'].show()
          this.modalSettings.openModal = false
        }
        if (this.modalSettings.closeModal == true) {
          this.$refs['main-modal'].hide()
          this.modalSettings.closeModal = false
        }
      },
    },
  },
}
</script>
